<template>
  <div>
    <menu-bar></menu-bar>
    <div class="main-container">
      <el-container style="margin: 0 auto;width: 1650px">
        <el-header style="height: 100%;margin-top: 20px;display: flex;justify-content: space-between">
<!--          <web-socket ref="webSocket"></web-socket>-->
          <unusual-change></unusual-change>
          <div style="display: inline-block">
            <el-card style="width: 620px" :body-style="{ padding: '0px'}">
              <div style="width: 100%">
                <div style="min-height: 100px;margin:auto">
                  <el-carousel :interval="3000">
                    <el-carousel-item :key="index" v-for="(carousel,index) of this.carousels">
                      <div style="text-align: center;position: relative">
                        <img style="cursor: pointer;height:300px" :src="carousel.src"
                             @click="routerChanger(carousel.router)">
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </el-card>
          </div>
        </el-header>

        <el-main>
          <div>
            <el-tabs v-model="activeTab" @tab-click="changeTab" type="border-card">
              <el-tab-pane label="Csgo" name="csgo">
                <h4 slot="label" class="tabTitle">
                  <strong>
                    <img src="static/imgs/logo_csgo_black.png">
                    CSGO
                  </strong>
                </h4>
                <home-page-table
                  :game="'csgo'"
                  :sticker-capsule-options="stickerCapsuleOptions"
                  :weapon-cases-index="weaponCasesIndex"
                  :category-options="categoryOptions"
                  :weapon-cases-options="weaponCasesOptions"
                  @unlockMore="unlockMore"
                ></home-page-table>
              </el-tab-pane>
              <el-tab-pane label="Dota2" name="dota2" :lazy="true">
                <h4 slot="label" class="tabTitle">
                  <strong>
                    <img src="static/imgs/logo_dota_black.png">
                    DOTA2
                  </strong>
                </h4>
                <home-page-table
                  :game="'dota2'"
                ></home-page-table>
              </el-tab-pane>
              <el-tab-pane label="Rust" name="Rust" :lazy="true">
                <h4 slot="label" class="tabTitle">
                  <strong>
                    <img style="height:16px;vertical-align: -3%" src="static/imgs/logo_rust_black.svg">
                    Rust
                  </strong>
                </h4>
                <home-page-table
                  :game="'rust'"
                ></home-page-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-main>
        <el-footer style="height: 45px">
          <div class="footer-row-brand">
            <div class="neutral">
              © 2024 hangKnife.com
            </div>
            <div class="footer-button-support">
              <div>Q群: 308356849</div>
              <div>email: 2547062163@qq.com</div>
            </div>
          </div>
        </el-footer>
      </el-container>
    </div>
  </div>
</template>

<script>
import Inventory from "../ui/TradeUp";
import HomePageTable from "../ui/HomePage/homePageTable";
import {mixins} from "../mixin";
import MenuBar from "../ui/Menu/menuBar.vue";
import WebSocket from "../ui/WebSocket/WebSocket.vue";
import UnusualChange from "../ui/UnusualChange/UnusualChange.vue";

const {allCurrencyOptions} = require("../api/api");

export default {
  name: 'Home',
  components: {UnusualChange, WebSocket, MenuBar, HomePageTable, Inventory},
  mixins: [mixins],
  data() {
    return {
      activeTab: 'csgo',
      activeRouter: 'first',
      referenceDisCount: 0,
      echarts: {},
      echartsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          }
        },
        calculable: true,
        legend: {
          data: ['日期'],
          itemGap: 5
        },
        grid: {
          height: '90%',
          left: '10%',
          right: '10%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: ''
          }
        ],
        dataZoom: [
          {
            show: true,
            bottom: '5%',
            start: 0,
            height: 15,
            end: 100
          },
          {
            type: 'inside',
            start: 0,
            end: 100
          },
          {
            show: true,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 15,
            height: '90%',
            showDataShadow: false,
            right: '5%',
            bottom: '5%',
            start: 65
          }
        ],
        series: [
          {
            name: '挂刀比例',
            smooth: true,
            type: 'line',
            data: [],
            markPoint: {
              data: []
            }
          },
        ]
      },
      carousels: []
    }
  },
  methods: {
    randomCarousel() {
      let elements = [
        // {src: '../../../static/imgs/186.jpg', router: 'https://186.yousheng186.com/?promotionCode=HKNF'},
        // {src: '../../../static/imgs/Binance1.png', router: 'https://www.marketwebb.net/join?ref=141682651'},
        {src: '../../../static/imgs/tradeitGG.png', router: 'https://tradeit.gg/?aff=hangKnife'},
        // {src: 'static/imgs/haloSkins.png', router: 'https://www.haloskins.com/zh-CN/market?channelCode=hangknife&gaSign=1'},
        // {src: '../../../static/imgs/NSDA.png', router: 'https://steamnsda.com/'},
        // {src: '../../../static/imgs/eco.png', router: 'https://share.ecosteam.cn/promotion?channel=X4B1U0'},
        // {src: '../../../static/imgs/97frog.png', router: 'https://www.97frog.com'},
        // {src: 'static/imgs/leigod.png', router: 'https://www.leigod.com/activitys/exchangeWordOfCommand.html'},
        // {src: '../../../static/imgs/C5Game.jpg', router: 'https://www.c5game.com/'}
      ]
      // 随机排列数组
      for (var i = elements.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = elements[i];
        elements[i] = elements[j];
        elements[j] = temp;
      }
      // elements.push({
      //   src: 'static/imgs/hangknifePoster.png',
      //   router: 'https://www.hangknife.com/'
      // })
      this.carousels = elements
    },
    unlockMore(){
      this.$refs.webSocket.listenDialog = true
    },
    routerChanger(url) {
      window.open(url)
    },
    changeTab(val1) {
      this.activeTab = val1.name
    },
  },
  created() {
    this.randomCarousel();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.neutral {
  display: block;
  height: 100%;
  width: auto;
}

.footer-button-support {
  text-align: center;
}

.footer-row-brand {
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgb(150, 157, 171);
  font-weight: 400;
  font-size: 14px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.steamDealTable td {
  min-width: 100px;
  text-align: center;
}

.header-menu h1 {
  margin: 0;
  float: left;
  position: absolute;
  font-size: 26px;
  top: 12px;
  color: #409EFF;
  left: 7%;
  font-weight: 400;
}

.box-card {
  height: 144px;
  display: inline-block;
}

body, dd, div, dl, dt, form, h1, h2, h3, h4, h5, h6, ol, p, ul {
  padding: 0;
  /*margin: 0 !important;*/
}

.tabTitle {
  margin: 0 !important;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue